import { QUOTE_EFFECTS, QUOTE_SERVICES, QuoteFeatureKey, QuoteReducer, UISharedModule } from '@accuservpro/xplat/features';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { QUOTE_COMPONENTS } from './components';

const MODULES = [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, UISharedModule];
const STATE = [StoreModule.forFeature(QuoteFeatureKey, QuoteReducer), EffectsModule.forFeature(QUOTE_EFFECTS)];
@NgModule({
  imports: [...MODULES, ...STATE], //
  declarations: [...QUOTE_COMPONENTS],
  exports: [...MODULES, ...QUOTE_COMPONENTS],
  providers: [...QUOTE_SERVICES],
})
export class WebQuoteModule {}
